const riot = require('riot');

riot.tag2('page-projects-single', '<div class="s-full f"> <div class="flex-fixed" data-is="module-sidebar"></div> <div class="h-full w0 flex-auto f fclm bg-pale_gray"> <div class="flex-fixed bg-white" data-is="module-page-header" project="{project}" title="{project.name}"> <yield to="right"> <button class="button primary" if="{opts.project}" onclick="{parent.onCreateCampaign}">キャンペーン新規作成</button> <button class="button primary" if="{!opts.project}" onclick="{parent.onGoProjectSingle}">プロジェクト新規登録</button> </yield> </div> <div class="f fclm h0 flex-auto w-full py36 px40"> <div class="f fclm flex-height-auto w-full overflow-hidden rounded-8 bg-white elevation-default-low" if="{project}"> <div class="flex-height-auto w-full" data-is="module-table" schemas="{tableSchemas}" items="{campaigns}" scroll-type="y"></div> <div class="flex-fixed f fr px28"> <div ref="pagination" data-is="atom-pagination" pagination="{pagination}"></div> </div> </div> </div> </div> </div>', 'page-projects-single,[data-is="page-projects-single"]{display:block}', '', function(opts) {

    this.isLoading = true;
    this.limit = 50;

    this.tableSchemas = [
      {
        id: 'name',
        label: 'キャンペーン名',
        component: 'link',
        getLink: (item) => `${location.pathname}/campaigns/${item.id}`,
      },
    ];

    this.preload = async ({req, res}) => {
      if (spat.isNode) return;
      this.isLoading = true;
      this.update();

      var company_id = req.params.company_id;
      var project_id = req.params.project_id;
      if (project_id !== 'new') {
        var { project } = await app.api.child(`companies/${company_id}/projects/${project_id}`).get({});

        if (project) {
          var {campaigns, pagination} = await app.api.child(`companies/${company_id}/projects/${project.id}/campaigns`).get({limit: this.limit, offset: 0});
        }
        this.project = project;
        this.campaigns = campaigns || null;
        this.pagination = pagination || null;

        this.isLoading = false;
        this.update();

        this.refs.pagination.on('paginationchange', async (offset_type) => {
          var indicator = spat.modal.indicator();
          var offset = this.pagination[offset_type];
          try {
            var {campaigns, pagination} = await app.api.child(`companies/${company_id}/projects/${this.project.id}/campaigns`).get({limit: this.limit, offset });
            this.campaigns = campaigns;
            this.pagination = pagination;
            this.update();
          }
          catch (e) {
            console.error(e);
            spat.modal.alert(e.message);
          }
          finally {
            indicator.close();
          }
        });
      }
    };

    this.head = () => {
      return {
        title: app.utils.head.title('ダッシュボード', this),
      };
    };

    this.onCreateCampaign = (e) => {
      e.preventDefault();
      spat.router.push(`${location.pathname}/campaigns/new/edit`);
    };

    this.onGoProjectSingle = () => {
      spat.router.push(`${location.pathname}/edit`);
    };
});